// extracted by mini-css-extract-plugin
export var navMenu = "NavMenu-module--nav-menu--KtPxp";
export var isActive = "NavMenu-module--is-active--2lPYI";